import type { EstadoMiembro, Fiduciante, Miembro, PasswordTemporal, Rol } from "./api";
import type { OpcionBuscable } from "./buscar";
import { formatFechaLocal } from "./format";

export const ETIQUETA_ROL: Record<Rol, string> = {
  admin: "Administrador",
  fiduciante: "Fiduciante",
  contador: "Contador",
  escribano: "Escribano",
};

export const OPCIONES_ROL = (Object.keys(ETIQUETA_ROL) as Rol[]).map((rol) => ({ valor: rol, etiqueta: ETIQUETA_ROL[rol] }));

export const ETIQUETA_ESTADO: Record<EstadoMiembro, string> = {
  activo: "Activo",
  invitacion_pendiente: "Invitación pendiente",
  primer_ingreso: "Falta el primer ingreso",
  temporal_vencida: "Contraseña vencida",
  desactivado: "Desactivado",
};

export const TONO_ESTADO: Record<EstadoMiembro, "exito" | "alerta" | "neutro"> = {
  activo: "exito",
  invitacion_pendiente: "alerta",
  primer_ingreso: "alerta",
  temporal_vencida: "alerta",
  desactivado: "neutro",
};

export const MIN_PASSWORD = 10;

export const MENSAJE_INVITACION_INVALIDA = "Este link no es válido o ya venció. Pedile uno nuevo al administrador.";

export function validarPasswordNueva(nueva: string, repetida: string): string | null {
  if (nueva.length < MIN_PASSWORD) return `La contraseña tiene que tener al menos ${MIN_PASSWORD} caracteres`;
  if (nueva !== repetida) return "Las contraseñas no coinciden";
  return null;
}

/** Lo que se muestra una sola vez para copiar y dictar. */
export interface TemporalGenerada {
  nombre: string;
  password: string;
  vence: string;
}

export function temporalGenerada(nombre: string, t: PasswordTemporal): TemporalGenerada {
  return { nombre, password: t.password, vence: formatFechaLocal(t.vence_en) };
}

/** Fichas de fiduciante sin usuario: las que se pueden vincular a un usuario con rol fiduciante. */
export function fichasLibres(fiduciantes: readonly Fiduciante[]): Fiduciante[] {
  return fiduciantes.filter((f) => f.usuario_id === null);
}

export function opcionesFichas(fichas: readonly Fiduciante[]): (OpcionBuscable & { detalle: string | null })[] {
  return fichas.map((f) => ({ valor: String(f.id), etiqueta: f.nombre, detalle: f.email, busqueda: f.email ?? undefined }));
}

/** Columna Rol de Usuarios: "Fiduciante · Juan Pérez" con la ficha vinculada. */
export function etiquetaRolMiembro(m: Miembro): string {
  return m.rol === "fiduciante" && m.fiduciante ? `${ETIQUETA_ROL.fiduciante} · ${m.fiduciante.nombre}` : ETIQUETA_ROL[m.rol];
}

/** Un fiduciante sin ficha (de antes de que fuera obligatoria): se ofrece "Vincular". */
export function sinVincular(m: Miembro): boolean {
  return m.rol === "fiduciante" && m.fiduciante === null;
}
